import ajax from "./ajax";

export function addCompany(params) {
  return ajax(`/JobCampany/CreateCompany`, { method: "POST", data: params });
}

export function getCompanies(params = "") {
  return ajax(`/JobCampany/GetAllCompanies?sort=-id${params}`);
}

export function getSingleCompany(id) {
  return ajax(`/JobCampany/GetCompanyById/${id}`);
}

export function updateCompany(id, data) {
  return ajax(`/JobCampany/UpdateCompany/${id}`, { method: "PUT", data });
}
